import React from 'react';
import classNames from 'classnames/bind';
import styles from './EasyPenMobile.scss';

const cx = classNames.bind(styles);

const EasyPenMobile = ({ initModal }) => {
  return (
    <div className={cx('EasyPenMobile')}>
      <div className="detail-wrap-box">
        <div className="close" onClick={initModal}></div>
        <div className="detail-title">
          <h2>이지펜 상세 스펙</h2>
        </div>

        <div className="datail-contents">
          <div className="detail-subtitle">
            <h3>제품 정보</h3>
          </div>
          <div className="detail-text">
            <ul className="detail-text-list">
              <li className="list">
                <span className="title">제품명</span>
                <span className="text">이지펜 (Easy Pen)</span>
              </li>
              <li className="list pb-21">
                <span className="title">기자재의 명칭</span>
                <span className="text">완구</span>
              </li>
              <li className="list">
                <span className="title">모델명</span>
                <span className="text">P40</span>
              </li>
              <li className="list">
                <span className="title">제조자</span>
                <span className="text">시노텍코리아(주)</span>
              </li>
              <li className="list">
                <span className="title">공급자</span>
                <span className="text">(주)퀄슨</span>
              </li>
              <li className="list">
                <span className="title">구성품</span>
                <span className="text">
                  이지펜 본체, USB 충전 케이블, 사용 설명서
                </span>
              </li>
            </ul>
          </div>

          <div className="detail-subtitle">
            <h3>제품 사양</h3>
          </div>
          <div className="detail-text">
            <ul className="detail-text-list">
              <li className="list">
                <span className="title">배터리</span>
                <span className="text">420mAh 내장 배터리</span>
              </li>
              <li className="list">
                <span className="title">스피커</span>
                <span className="text">1.0W 내장 스피커</span>
              </li>
              <li className="list">
                <span className="title">메모리</span>
                <span>16GB</span>
              </li>
              <li className="list">
                <span className="title">PC 인터페이스</span>
                <span className="text">USB 2.0</span>
              </li>
              <li className="list">
                <span className="title">크기</span>
                <span className="text">125mm X 25mm X 20mm</span>
              </li>
              <li className="list">
                <span className="title">무게</span>
                <span className="text">50g</span>
              </li>
              <li className="list">
                <span className="title">KC 인증번호</span>
                <span className="text">CB064R230-8001</span>
              </li>
              <li className="list">
                <span className="title">제조일자</span>
                <span className="text">별도표기</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EasyPenMobile;
